import React, { Component } from "react";

class ServiceInformation extends Component {
	constructor(props) {
		super(props);
		var bgClass = props.background === "dark" ? "special-row" : "";
		this.state = { backgroundClass: bgClass, html: null, loading: true };
	}
	render() {
		return (
			<section id="visit-us" className={`padding100 ${this.state.backgroundClass}`}>
				<div className="container">
					<h1 className="text-center">
						<strong>Service Information</strong>
					</h1>
					<div className="divider">
						<i className="fa fa-star"></i>
					</div>

					<p className="lead">
						{" "}
						Kingston Christian Reformed Church meets at 10:00am and 4:30pm on Sundays at 17 Denison St, Kingston
					</p>

					<div className="white-row">
						{/*<!-- google map -->*/}
						<div id="gmap"></div>

						<div className="divider white half-margins">
							{/*<!-- divider -->*/}
							<i className="fa fa-star"></i>
						</div>

						<p className="nomargin-bottom text-center">
							<span className="block">
								<strong>
									<i className="fa fa-clock-o"></i> Weekly Service:
								</strong>{" "}
								10:00am & 4:30pm Sundays
							</span>
							<span className="block">
								<strong>
									<i className="fa fa-map-marker"></i> Address:
								</strong>{" "}
								17 Denison St, Kingston
							</span>
							<span className="block">
								<strong>
									<i className="fa fa-phone"></i> Phone:
								</strong>{" "}
								(03) 6229 2268
							</span>
							<span className="block">
								<strong>
									<i className="fa fa-envelope"></i> Email:
								</strong>{" "}
								<a href="mailto:office@kingstoncrc.org.au">office@kingstoncrc.org.au</a>
							</span>
						</p>
					</div>
					<p className="lead">
						So that you know what to expect, an average service goes for about 65 minutes and includes Bible reading, a
						25 minute sermon, prayer, singing, information about what's going on in the wider life of the church, and a
						children's talk.
					</p>
					<p className="lead">
						Our kid’s programs run during our 10:00am service. These include creche (6mths-4years), Children’s Church
						(Kinder-Prep) and Kid’s Biz (Yr 1-4).
					</p>
				</div>
			</section>
		);
	}
}

export default ServiceInformation;
